import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FaqPage from "./pages/FaqPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import CourierCharges from "./pages/CourierCharges";
import CountriesPage from "./pages/CountriesPage";
import CountryDetail from "./pages/CountryDetail";
import CustomsClearance from "./pages/CustomsClearance";
import CustomsClearanceDetail from "./pages/CustomsClearanceDetail";
import LocationsPage from "./pages/LocationsPage";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/countries" element={<CountriesPage />} />
            <Route path="/country/:slug" element={<CountryDetail />} />
            <Route path="/customs-clearance" element={<CustomsClearance />} />
            <Route path="/customs-clearance/:slug" element={<CustomsClearanceDetail />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/courier-charges" element={<CourierCharges />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
